/** Set to false to re-show the Mobile Guest IVR Setting panel on Work Orders. */
export const HIDE_MOBILE_GUEST_IVR_SETTING_PANEL = true;
